// export attributes as .
// Heading / h2

import { Box, Stack, StackProps } from '@ff-it/ui';
import { ReactElement, ReactNode } from 'react';

type HeaderProps = {
  heading?: ReactNode;
  menu?: ReactNode;
  actions?: ReactNode;
  attributes?: ReactNode;
  metaAttributes?: ReactNode;
};

// @TODO slots? type icon

export function Header({ heading, attributes, menu, actions, metaAttributes }: HeaderProps): ReactElement {
  // horizontal or vertical? if horizontal we want columns here
  return (
    <Stack px="3" py="2" direction="horizontal" space="6" borderBottom="subtle" marginBottom="2">
      {/* left column */}
      <Stack direction="vertical" align="start" justify="between">
        <Stack direction="horizontal" align="center">
          {heading && <Heading>{heading}</Heading>}
          {attributes}
        </Stack>
        {menu}
      </Stack>
      {/* right column */}
      {(actions || metaAttributes) && (
        <Stack direction="vertical" ml="auto" align="end" justify="center">
          {metaAttributes}
          {actions}
        </Stack>
      )}
    </Stack>
  );
}

function Heading({ children }: { children: ReactNode }): ReactElement {
  // horizontal or vertical? if horizontal we want columns here
  return (
    <Box as="h2" fontWeight="medium" textSize="sm" color="gray700" my="0">
      {children}
    </Box>
  );
}
type AttributeProps = {
  children: ReactNode;
  label?: ReactNode;
};

function Attribute({ label, children }: AttributeProps): ReactElement {
  return (
    <Box>
      {label && (
        <Box as="span" pr="1" color="gray500">
          {label}
        </Box>
      )}
      {children}
    </Box>
  );
}

type AttributeContainerProps = StackProps;

function AttributeContainer({ children, ...rest }: AttributeContainerProps): ReactElement {
  return (
    <Stack direction="horizontal" space="2" textSize="xs" align="center" {...rest} color="gray700">
      {children}
    </Stack>
  );
}

Header.Attribute = Attribute;
Header.AttributeContainer = AttributeContainer;
